(function () {
  angular.module('binky.core.ready', ['binky.core.lodash']);
})();
